import { fetcher } from "@/lib/api/fetcher";
import { environments } from "@/lib/config";

import { MemberProfile } from "@/types/customer-management";
import { MediaDoohInfo } from "@/types/signup";
import { UserLoginType } from "@/types/user";

const apiUrl = environments.restApiUrl;
const apiCMSUrl = environments.cmsApiUrl;

export const userLogin = (body: UserLoginType) => {
  return fetch(`${apiUrl}/auth/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ user_email: body.email, user_pwd: body.password }),
  }).then((res) => {
    const resData = res.json();
    return resData;
  });
};

export const userCMSLogin = (body: UserLoginType) => {
  return fetch(`${apiCMSUrl}/login`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ id: body.email, password: body.password }),
  }).then((res) => {
    const resData = res.json();
    return resData;
  });
};

export const getUserProfile = (userId: string | number) => {
  return fetcher<MemberProfile>(`${apiUrl}/user/${userId}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const getMyProfile = () => {
  return fetcher(`${apiUrl}/auth/me`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const userLogout = () => {
  return fetcher(`${apiUrl}/auth/logout`, {
    method: "POST",
  });
};

export async function refreshToken() {
  const isServer = typeof window === "undefined";

  const fetchOptions: RequestInit = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    ...(isServer ? {} : { credentials: "include" }),
  };

  if (isServer) {
    const { cookies } = await import("next/headers");
    const cookieStore = await cookies();
    const cookieString = cookieStore
      .getAll()
      .map((c) => `${c.name}=${c.value}`)
      .join("; ");
    if (cookieString) {
      fetchOptions.headers = {
        ...fetchOptions.headers,
        Cookie: cookieString,
      };
    }
  }

  const res = await fetch(`${apiUrl}/auth/refresh-token`, fetchOptions);

  const isJson = res.headers.get("content-type")?.includes("application/json");
  const data = isJson ? await res.json() : await res.text();

  return { status: res.status, data };
}

export const getIDPInfo = () => {
  return fetcher<{ data: MediaDoohInfo }>(`${apiUrl}/auth/idp-info`, {
    method: "GET",
  });
};
